/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import Application from 'flarum/common/Application';
import CustomFooter from '../components/CustomFooter';

export default function () {
	// @ts-expect-error -- deliberate patch of the protected `Application.mount`
	extend(Application.prototype, 'mount', () => {
		const footer = document.createElement('footer');
		m.mount(document.body.appendChild(footer), CustomFooter);
	});
}
